/**
 * @generated SignedSource<<f95ffc40def01249ff17bae6c3cc3523>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "SetUserPermissionsPayload",
            "kind": "LinkedField",
            "name": "setUserPermissions",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userPermissions",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserPermissionsUpdateModal_setUserPermissionsMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserPermissionsUpdateModal_setUserPermissionsMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "438939629558cc32ab9c921adf1a851f",
            "id": null,
            "metadata": {},
            "name": "UserPermissionsUpdateModal_setUserPermissionsMutation",
            "operationKind": "mutation",
            "text": "mutation UserPermissionsUpdateModal_setUserPermissionsMutation(\n  $model: SetUserPermissionsRequestInput!\n) {\n  setUserPermissions(model: $model) {\n    user {\n      id\n      userPermissions\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "17911e82c6c77e8b86475ba0587137f0";
export default node;
